/* eslint-disable prettier/prettier */
export const configs = {
  Version: "2.5.0.0",
  WithEntities: false,
  CurrentIsProd: true,
  ClientID: "fb60273f-9e78-4d5c-83f2-6ee0fd838757",
  Authority: "https://login.microsoftonline.com/common",
  RedirectWithDevURI: "https://localhost:3000/login/login.html",
  RedirectWithProdURI: "https://otsp2.z6.web.core.windows.net/login/login.html",
  TenantID: "705c6e47-bdf3-4fc0-9bad-84965f7302fd",
  RedirectDevURI: "https://localhost:3000/login.html",
  RedirectProdDevURI: "https://otsp2.z6.web.core.windows.net/login.html",
  SiteRoot: "https://psarakisantonis.sharepoint.com",
  alertSiteID: "440debda-2842-415b-b18c-35413e988f38",
  skatules: 0,
  //StaticSiteURL: "https://localhost:3000/",
};
